import { FormControl, Stack, TextField } from '@mui/material'
import React from 'react'
import { Controller, useFormContext } from 'react-hook-form'

import { type AuthenticationFormValues } from 'components/status-checks/authentication-form-utils'
import { useObservabilityToolAuthenticationContext } from 'context/status-checks/ObservabilityToolAuthenticationContext'

export const ObservabilityToolPrometheusAuthenticationUserPasswordDetails =
  () => {
    const { isEdit } = useObservabilityToolAuthenticationContext()
    const { control, setValue } = useFormContext<AuthenticationFormValues>()

    /*
     * Clear all authentication fields in the event that we even attempt to
     * update the value of even one of the fields. Check whether the value of the
     * field is equal to our placeholder string such that we don't continue to clear
     * the field after valid input has been entered.
     */
    function clearAuthenticationFields(
      _event: React.FocusEvent<HTMLInputElement | HTMLTextAreaElement>,
      isTouched: boolean
    ) {
      if (isTouched) return

      setValue('headers', [], { shouldDirty: true })
      setValue('secret', '', { shouldDirty: true })
      setValue(
        'authentication',
        { username: '', password: '' },
        { shouldDirty: true, shouldTouch: true }
      )
    }

    return (
      <Stack spacing={2} sx={{ maxWidth: 400 }}>
        <FormControl>
          <Controller
            control={control}
            name="authentication.username"
            render={({ field, fieldState: { error, isTouched } }) => (
              <TextField
                {...field}
                autoComplete="off"
                error={Boolean(error)}
                helperText={error?.message}
                label="Username"
                type={isEdit ? 'password' : 'text'}
                {...(isEdit && {
                  onFocus: (event) => {
                    clearAuthenticationFields(event, isTouched)
                  }
                })}
              />
            )}
          />
        </FormControl>
        <FormControl>
          <Controller
            control={control}
            name="authentication.password"
            render={({ field, fieldState: { error, isTouched } }) => (
              <TextField
                {...field}
                autoComplete="off"
                error={Boolean(error)}
                helperText={error?.message}
                label="Password"
                type="password"
                {...(isEdit && {
                  onFocus: (event) => {
                    clearAuthenticationFields(event, isTouched)
                  }
                })}
              />
            )}
          />
        </FormControl>
      </Stack>
    )
  }
